(function (Drupal, once) {
  Drupal.behaviors.contactListBehavior = {
    attach: function (context) {

      once('contact-list', '[data-contact-list-form]', context).forEach(function (form) {
        const select = form.querySelector('select');
        const button = form.querySelector('button');

        if (!select || !button) {
          return;
        }

        button.addEventListener('click', function () {
          const url = select.value;
          if (url) {
            window.location.href = url;
          }
        });
      });

    }
  };
})(Drupal, once);
